import { bool, func, oneOfType, number, shape, string } from 'prop-types';
import { Combobox, FormError, FormLabel } from '../../../../components/common';
import { PATTERNS } from '@laramie/ui';
import { aplicaAntiguedadMinima, getAnioModeloError } from '../../utils';

// Campos del gate de alta de Vehículo (espejo del NEW viejo): los reusan la grilla
// y el selector de cuentas. onChange recibe un patch parcial del estado del gate.
const VehiculoGateFields = ({ gate, onChange }) => {
    const anioModeloError = getAnioModeloError(gate.anioModelo, aplicaAntiguedadMinima(gate));

    return (
        <>
            <div className="mb-3">
                <FormLabel htmlFor="idIncisoVehiculo" required>Inciso</FormLabel>
                <Combobox
                    name="idIncisoVehiculo"
                    className="form-control"
                    entidad="IncisoVehiculo"
                    value={gate.idIncisoVehiculo}
                    onChange={({ target }) => onChange({
                        idIncisoVehiculo: target.row ? parseInt(target.value) : 0,
                        vehiculoMenor: target.row ? target.row.vehiculoMenor : false,
                        idTipoVehiculo: 0
                    })}
                />
            </div>
            <div className="mb-3">
                <FormLabel htmlFor="idTipoVehiculo" required>Tipo</FormLabel>
                <Combobox
                    name="idTipoVehiculo"
                    className="form-control"
                    entidad="TipoVehiculo"
                    filter={(row) => row.idIncisoVehiculo === gate.idIncisoVehiculo}
                    disabled={gate.idIncisoVehiculo <= 0}
                    value={gate.idTipoVehiculo}
                    onChange={({ target }) => onChange({
                        idTipoVehiculo: target.row ? parseInt(target.value) : 0
                    })}
                />
            </div>
            <div className="mb-3">
                <FormLabel htmlFor="anioModelo" required>Año/Modelo</FormLabel>
                <input
                    name="anioModelo"
                    type="text"
                    placeholder=""
                    className={`form-control ${anioModeloError ? 'is-invalid' : ''}`}
                    pattern={PATTERNS.onlyNumbers}
                    maxLength={4}
                    disabled={gate.idTipoVehiculo <= 0}
                    value={gate.anioModelo}
                    onChange={({ target }) => {
                        if (target.validity.valid) {
                            onChange({ anioModelo: target.value });
                        }
                    }}
                />
                <FormError message={anioModeloError} />
            </div>
            <div className="mb-3">
                <FormLabel htmlFor="dominio" required>Dominio</FormLabel>
                <input
                    name="dominio"
                    type="text"
                    placeholder=""
                    className="form-control"
                    autoComplete="off"
                    pattern={PATTERNS.onlyNumbersAndLetters}
                    value={gate.dominio}
                    onChange={({ target }) => {
                        if (target.validity.valid && target.value.length <= 7) {
                            onChange({ dominio: target.value.toUpperCase() });
                        }
                    }}
                />
            </div>
        </>
    );
};

VehiculoGateFields.propTypes = {
    gate: shape({
        idIncisoVehiculo: number,
        vehiculoMenor: bool,
        idTipoVehiculo: oneOfType([number, string]),
        anioModelo: string,
        dominio: string
    }).isRequired,
    onChange: func.isRequired
};

export default VehiculoGateFields;
